import axios from 'axios';
import { message } from 'antd';
import { getApiBaseUrl, CONNECTION_STORAGE_KEY } from './backendConnection';

// Keep every tab on the same backend and discard any old authenticated view.
window.addEventListener('storage', event => {
  if (event.key === CONNECTION_STORAGE_KEY) window.location.reload();
});

// 创建axios实例
const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000, // 普通接口的默认值；匹配相关请求使用后端计算的完整流程等待时间。
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const matchingRequest = config.method === 'post' && (config.url === '/partner-push/preview' ? 'previewTimeoutMs' :
      /^\/push-records\/[^/]+\/manual-submit$/.test(config.url) ? 'manualSubmitTimeoutMs' : null);
    if (matchingRequest) {
      // 每次操作重新读取，保存或切换激活模型后立即生效；此 GET 不会再次进入匹配分支。
      const { data } = await api.get('/ai-config/matching-timeouts', { silentError: true });
      const timeout = data?.[matchingRequest];
      if (!Number.isSafeInteger(timeout) || timeout <= 0) {
        // 配置无效时停止操作，避免回退到不足的 30 秒或以 0 关闭超时后发起手动提交。
        const error = new Error('无法读取匹配等待设置，请刷新后重试');
        error.code = 'MATCH_TIMEOUT_CONFIG_UNAVAILABLE';
        error.config = config;
        return Promise.reject(error);
      }
      config.timeout = timeout;
    }
    // 调试信息 (仅在开发环境显示)
    if (process.env.NODE_ENV === 'development') {
      console.log('API Request:', config.method?.toUpperCase(), config.url, config.params);
    }
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('API Response:', response.status, response.config.url);
    }
    return response;
  },
  (error) => {
    console.error('API Error:', error.message, error.config?.url, error.response?.status);
    if (error.config?.silentError && error.response?.status !== 401) return Promise.reject(error);
    
    if (error.response) {
      const { status, data } = error.response;
      
      switch (status) {
        case 401:
          // 未授权，清除token并跳转到登录页
          localStorage.removeItem('token');
          if (window.location.pathname !== '/login') {
            window.location.href = '/login';
          }
          break;
        case 403:
          message.error('权限不足');
          break;
        case 404:
          message.error('请求的资源不存在');
          break;
        case 500:
          message.error('服务器内部错误');
          break;
        default:
          if (data?.message) {
            message.error(data.message);
          } else {
            message.error('请求失败');
          }
      }
    } else if (error.request) {
      console.error('Network error:', error.request);
      if (error.code === 'NETWORK_ERROR' || error.code === 'ERR_NETWORK') {
        message.error('无法连接后端，可在“后端连接”中检查地址并测试连接');
      } else if (error.code === 'TIMEOUT' || error.message.includes('timeout')) {
        message.error('请求超时，请重试');
      } else {
        message.error('网络请求失败，请检查服务器状态');
      }
    } else {
      console.error('Request config error:', error.message);
      message.error('请求配置错误');
    }
    
    return Promise.reject(error);
  }
);

export default api;
